module.exports = __webpack_public_path__ + "img/shimfo_img.4bb69bf3.png";